<template>
  <v-card>
    <v-toolbar flat color="white" density="compact">
      <v-spacer/>
      <div class="chip-container">
        <base-action-button v-if="canEdit" @action="addProcedureStep">
          <template #prepend><PhPlus style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
          {{ $store.getters.translate("add") + ' ' + $store.getters.translate("procedurestep") }}
        </base-action-button>
        <base-action-button v-if="canEdit" @action="save">
          <template #prepend><PhFloppyDisk style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
          {{ $store.getters.translate("save") }}
        </base-action-button>
      </div>
    </v-toolbar>
    <v-data-table
        id="base_table_procedure_results"
        :headers="headers"
        :items="record.procedure_results"
        class="elevation-1"
        :show-select="false"
        :items-per-page="100">
      <template #body="{ items }">
        <draggable :disabled="!canEdit" :list="items" tag="tbody" @end="endDrag(items)" item-key="id">
          <template #item="{ element:procedure_result }">
            <tr class="sm-normal text-primary">
              <td><PhArrowsVertical size="20" weight="bold" style="cursor: pointer; vertical-align: middle;"/></td>
              <td>{{ procedure_result.sort_order }}</td>
              <td>{{ procedure_result.name }}</td>
              <td>{{ procedure_result.description }}</td>
              <td>
                <v-icon v-if="procedure_result.result" color="success" size="large" icon="mdi-check-all"/>
                <v-icon v-else color="error" size="large" icon="mdi-close"/>
              </td>
              <!--ACTION BUTTONS-->
              <td style="text-align: center; width: 80px;" v-if="canEdit">
                <v-menu>
                  <template #activator="{ props }">
                    <v-btn elevation="0" icon v-bind="props">
                      <PhDotsThreeVertical size="24" style="cursor: pointer;"/>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item v-if="canEdit" @click="deleteProcedureResult(procedure_result)">
                      <template #prepend><PhTrash size="24"/></template>
                      <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate('delete') }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
        </draggable>
      </template>
      <template #bottom/>
    </v-data-table>
  </v-card>
  <base-link-procedure-step ref="base_link_procedure_step" :parent_id="record.id" :excluded_names="$lodash.map(record.procedure_results, 'name')" @refresh="$emit('refresh')"/>
</template>

<script>
import { useAbility } from '@casl/vue';
import helpFunctions from "../../plugins/helpFunctions.js";
import draggable from "vuedraggable";
import BaseActionButton from "./BaseActionButton";
import { PhArrowsVertical, PhDotsThreeVertical, PhFloppyDisk, PhPlus, PhTrash } from "@phosphor-icons/vue";
import BaseLinkProcedureStep from "./BaseLinkProcedureStep";

export default {
  props: ["page", "record"],
  components: {
    BaseLinkProcedureStep,
    draggable,
    BaseActionButton,
    PhArrowsVertical, PhTrash, PhDotsThreeVertical, PhFloppyDisk, PhPlus
  },
  setup() {
    const { can } = useAbility()
    return { can }
  },
  data() {
    return {
      headers: helpFunctions.headers.procedure_results,
    };
  },
  beforeMount() {
    document.querySelector('#base_table_procedure_results > .v-table__wrapper > table > tbody')?.remove();
  },
  mounted() {
    const sortableTbody = document.querySelector('#base_table_procedure_results > .v-table__wrapper > table > tbody > tbody');
    // <draggable> ruin view in <tbody> (create a <div> tag inside <tbody>)
    //FIX: https://github.com/SortableJS/Vue.Draggable/issues/1212#issuecomment-1918880591
    if (sortableTbody) {
      const tbody = document.querySelector('#base_table_procedure_results > .v-table__wrapper > table > tbody')
      tbody.parentNode.append(sortableTbody);
      tbody.remove()
    }
  },
  methods: {
    addProcedureStep() {
      this.$refs.base_link_procedure_step.load();
    },
    async deleteProcedureResult(procedure_result) {
      await helpFunctions.deleteModel(this.$toast, "procedureresults", procedure_result.id);
      this.$emit('refresh');
    },
    save() {
      for (let i = 0; i < this.record.procedure_results.length; i++) {
        helpFunctions.saveModelSilently("procedureresults", this.record.procedure_results[i]);
      }
      this.$toast.success(this.$store.getters.translate("successfully_saved"));
    },
    endDrag(items) {
      let temp_records = this.record.procedure_results;
      for (let i = 0; i < temp_records.length; i++) {
        for (let z = 0; z < items.length; z++) {
          if (temp_records[i].id === items[z].id && temp_records[i].sort_order !== z + 1) {
            this.record.procedure_results[i].sort_order = z + 1;
          }
        }
      }
      this.record.procedure_results.sort((a, b) => a.sort_order - b.sort_order); // The table was not re-sorted in the previous algorithm, although the values were changed correctly.
    },
  },
  computed: {
    canEdit() {
      return this.can("edit", this.$createEntity(this.page.model.toLowerCase(), { id: 0 })) ||
          this.can("edit", this.$createEntity(this.page.model.toLowerCase(), { id: this.record.id }));
    },
  },
};
</script>

<style scoped>
.v-checkbox {
  display: flex;
}
.chip-container {
  display: flex;
  gap: 8px;
  margin-right: 16px;
}
</style>